// Home/Today client — talks to the gateway BFF GET /api/v1/home/today, which fans out to the
// per-user signal sources with the caller's bearer and returns ranked HomeSignal[] + per-source
// status (see docs/home/02-homesignal-contract.md, services/gateway/home.js).
import { gatewayApi } from '@/lib/hrApi';
import type { HomeTodayResponse } from './homeSignal';

export const getHomeToday = () =>
  gatewayApi.get<HomeTodayResponse>('/api/v1/home/today').then((r) => r.data);
